module.exports = __webpack_public_path__ + "img/canopy-tour--full.4f9fa432.jpg";